import SvgIcon from '@material-ui/core/SvgIcon';

type NotApplicableIconProps = {
  fontSize?: 'inherit' | 'medium' | 'default' | 'large' | 'small' | undefined;
};

export function NotApplicableIconLightTheme({
  fontSize,
}: NotApplicableIconProps) {
  return (
    <SvgIcon
      width="225"
      height="225"
      viewBox="0 0 225 225"
      fontSize={fontSize}
      style={{ width: 225, height: 225 }}
    >
      <circle cx="112.5" cy="112.5" r="112.5" fill="#E7E6F4" />
      <circle cx="44.5" cy="70.5" r="2.5" fill="#D9D9D9" />
      <path
        d="M163 53C163 40.2975 152.255 30 139 30C125.745 30 115 40.2975 115 53C115 65.7025 125.745 76 139 76"
        stroke="#037D5D"
        strokeDasharray="2 2"
        fill="none"
      />
      <path
        d="M102 162C102 174.703 91.2548 185 78 185C64.7452 185 54 174.703 54 162C54 149.297 64.7452 139 78 139"
        stroke="#037D5D"
        strokeDasharray="2 2"
        fill="none"
      />
      <path
        d="M36 159C36 163.418 39.5817 167 44 167H173C177.418 167 181 163.418 181 159V76.5H36V159Z"
        fill="white"
      />
      <path
        d="M181 72C181 67.5817 177.418 64 173 64H44C39.5817 64 36 67.5817 36 72V76.5H181V72Z"
        fill="#757C7D"
      />
      <rect x="40" y="84" width="59" height="14" fill="#F6F7F7" />
      <rect
        x="40"
        y="102"
        width="59"
        height="26"
        fill="#F6F7F7"
        fillOpacity="0.57"
      />
      <rect x="105" y="84" width="72" height="44" fill="#F6F7F7" />
      <rect x="40" y="134" width="137" height="27" fill="#F6F7F7" />
      <rect
        x="45"
        y="110"
        width="4"
        height="16"
        fill="#D9D9D9"
        fillOpacity="0.21"
      />
      <rect
        x="54"
        y="113"
        width="4"
        height="13"
        fill="#D9D9D9"
        fillOpacity="0.21"
      />
      <rect
        x="63"
        y="111"
        width="4"
        height="15"
        fill="#D9D9D9"
        fillOpacity="0.21"
      />
      <rect
        x="72"
        y="112"
        width="4"
        height="14"
        fill="#D9D9D9"
        fillOpacity="0.21"
      />
      <rect
        x="81"
        y="110"
        width="4"
        height="16"
        fill="#D9D9D9"
        fillOpacity="0.21"
      />
      <rect
        x="90"
        y="109"
        width="4"
        height="17"
        fill="#D9D9D9"
        fillOpacity="0.21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.625 148.667C177.095 148.667 185.583 140.179 185.583 129.708C185.583 119.238 177.095 110.75 166.625 110.75C156.155 110.75 147.667 119.238 147.667 129.708C147.667 140.179 156.155 148.667 166.625 148.667ZM166.625 151.583C178.706 151.583 188.5 141.79 188.5 129.708C188.5 117.627 178.706 107.833 166.625 107.833C154.544 107.833 144.75 117.627 144.75 129.708C144.75 141.79 154.544 151.583 166.625 151.583Z"
        fill="#666B6D"
      />
      <path
        d="M166.625 148.667C177.095 148.667 185.583 140.179 185.583 129.708C185.583 119.238 177.095 110.75 166.625 110.75C156.155 110.75 147.667 119.238 147.667 129.708C147.667 140.179 156.155 148.667 166.625 148.667Z"
        fill="white"
      />
      <path
        d="M183.061 147.955L181.59 148.119L181.218 149.464L192.782 163.245L194.606 161.714L183.061 147.955Z"
        fill="#666B6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.998 150.164L190.548 165.12C191.583 166.354 193.423 166.515 194.657 165.479L196.481 163.949C197.715 162.913 197.876 161.073 196.84 159.84L184.291 144.884L179.305 145.438L177.998 150.164ZM181.59 148.119L183.061 147.955L194.606 161.714L192.782 163.245L181.218 149.464L181.59 148.119Z"
        fill="#666B6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.516 120.984C180.495 125.964 180.495 134.036 175.516 139.016C170.536 143.995 162.464 143.995 157.484 139.016C152.505 134.036 152.505 125.964 157.484 120.984C162.464 116.005 170.536 116.005 175.516 120.984ZM172.439 137.943L158.557 124.061C155.645 127.945 155.955 133.48 159.488 137.012C163.02 140.545 168.555 140.855 172.439 137.943ZM173.512 122.988C177.045 126.52 177.355 132.055 174.443 135.939L160.561 122.057C164.445 119.145 169.98 119.455 173.512 122.988Z"
        fill="#BB3118"
      />
      <circle cx="51.5" cy="70.5" r="2.5" fill="#D9D9D9" />
      <circle cx="44.5" cy="70.5" r="2.5" fill="#D9D9D9" />
      <circle cx="58.5" cy="70.5" r="2.5" fill="#D9D9D9" />
      <path
        d="M106.098 143.384V152H105.282L100.458 145.148V152H99.4017V143.384H100.434L105.042 149.936V143.384H106.098ZM107.244 153.176L110.724 142.868H111.768L108.288 153.176H107.244ZM115.427 144.752L114.023 148.436H116.831L115.427 144.752ZM118.199 152L117.203 149.396H113.651L112.655 152H111.551L114.923 143.384H115.967L119.327 152H118.199Z"
        fill="#393C3D"
      />
      <path
        d="M137.105 103.256V109H136.561L133.345 104.432V109H132.641V103.256H133.329L136.401 107.624V103.256H137.105ZM137.829 109.784L140.149 102.912H140.845L138.525 109.784H137.829ZM143.245 104.168L142.309 106.624H144.181L143.245 104.168ZM145.093 109L144.429 107.264H142.061L141.397 109H140.661L142.909 103.256H143.605L145.845 109H145.093Z"
        fill="#393C3D"
      />
      <path
        d="M68.5788 89.192V93.5H68.1708L65.7588 90.074V93.5H65.2308V89.192H65.7468L68.0508 92.468V89.192H68.5788ZM69.1219 94.088L70.8619 88.934H71.3839L69.6439 94.088H69.1219ZM73.1837 89.876L72.4817 91.718H73.8857L73.1837 89.876ZM74.5697 93.5L74.0717 92.198H72.2957L71.7977 93.5H71.2457L72.9317 89.192H73.4537L75.1337 93.5H74.5697Z"
        fill="#393C3D"
      />
      <path
        d="M70.6051 113.256V119H70.0611L66.8451 114.432V119H66.1411V113.256H66.8291L69.9011 117.624V113.256H70.6051ZM71.3293 119.784L73.6493 112.912H74.3453L72.0253 119.784H71.3293ZM76.7449 114.168L75.8089 116.624H77.6809L76.7449 114.168ZM78.5929 119L77.9289 117.264H75.5609L74.8969 119H74.1609L76.4089 113.256H77.1049L79.3449 119H78.5929Z"
        fill="#393C3D"
      />
      <path
        d="M133.821 182.94H131.901C132.181 180.26 133.981 178.42 136.621 178.42C139.341 178.42 141.001 180 141.001 182.44C141.001 184.18 139.701 185.4 138.601 186.58C137.801 187.4 137.621 187.92 137.601 188.48H135.881C135.941 187.3 136.281 186.7 137.221 185.66C138.041 184.74 139.201 183.84 139.201 182.46C139.201 181 138.181 180.06 136.621 180.06C134.901 180.06 133.941 181.26 133.821 182.94ZM137.921 191.84C137.921 192.56 137.361 193.12 136.661 193.12C135.981 193.12 135.421 192.56 135.421 191.84C135.421 191.14 135.981 190.58 136.661 190.58C137.361 190.58 137.921 191.14 137.921 191.84Z"
        fill="#3B2A7B"
      />
      <path
        d="M79.6785 32.892H76.2225C76.7265 28.068 79.9665 24.756 84.7185 24.756C89.6145 24.756 92.6025 27.6 92.6025 31.992C92.6025 35.124 90.2625 37.32 88.2825 39.444C86.8425 40.92 86.5185 41.856 86.4825 42.864H83.3865C83.4945 40.74 84.1065 39.66 85.7985 37.788C87.2745 36.132 89.3625 34.512 89.3625 32.028C89.3625 29.4 87.5265 27.708 84.7185 27.708C81.6225 27.708 79.8945 29.868 79.6785 32.892ZM87.0585 48.912C87.0585 50.208 86.0505 51.216 84.7905 51.216C83.5665 51.216 82.5585 50.208 82.5585 48.912C82.5585 47.652 83.5665 46.644 84.7905 46.644C86.0505 46.644 87.0585 47.652 87.0585 48.912Z"
        fill="#3B2A7B"
      />
    </SvgIcon>
  );
}

export function NotApplicableIconDarkTheme({
  fontSize,
}: NotApplicableIconProps) {
  return (
    <SvgIcon
      width="225"
      height="225"
      viewBox="0 0 225 225"
      fontSize={fontSize}
      style={{ width: 225, height: 225 }}
    >
      <circle cx="112.5" cy="112.5" r="112.5" fill="#BCB9E8" />
      <circle cx="44.5" cy="70.5" r="2.5" fill="#D9D9D9" />
      <path
        d="M163 53C163 40.2975 152.255 30 139 30C125.745 30 115 40.2975 115 53C115 65.7025 125.745 76 139 76"
        stroke="#474B4C"
        strokeDasharray="2 2"
        fill="none"
      />
      <path
        d="M102 162C102 174.703 91.2548 185 78 185C64.7452 185 54 174.703 54 162C54 149.297 64.7452 139 78 139"
        stroke="#333333"
        strokeDasharray="2 2"
        fill="none"
      />
      <path
        d="M36 159C36 163.418 39.5817 167 44 167H173C177.418 167 181 163.418 181 159V76.5H36V159Z"
        fill="#333333"
      />
      <path
        d="M181 72C181 67.5817 177.418 64 173 64H44C39.5817 64 36 67.5817 36 72V76.5H181V72Z"
        fill="#666B6D"
      />
      <rect x="40" y="84" width="59" height="14" fill="#424242" />
      <rect x="40" y="102" width="59" height="26" fill="#424242" />
      <rect x="105" y="84" width="72" height="44" fill="#424242" />
      <rect x="40" y="134" width="137" height="27" fill="#424242" />
      <rect x="45" y="110" width="4" height="16" fill="#333333" />
      <rect x="54" y="113" width="4" height="13" fill="#333333" />
      <rect x="63" y="111" width="4" height="15" fill="#333333" />
      <rect x="72" y="112" width="4" height="14" fill="#333333" />
      <rect x="81" y="110" width="4" height="16" fill="#333333" />
      <rect x="90" y="109" width="4" height="17" fill="#333333" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.625 148.667C177.095 148.667 185.583 140.179 185.583 129.708C185.583 119.238 177.095 110.75 166.625 110.75C156.155 110.75 147.667 119.238 147.667 129.708C147.667 140.179 156.155 148.667 166.625 148.667ZM166.625 151.583C178.706 151.583 188.5 141.79 188.5 129.708C188.5 117.627 178.706 107.833 166.625 107.833C154.544 107.833 144.75 117.627 144.75 129.708C144.75 141.79 154.544 151.583 166.625 151.583Z"
        fill="#666B6D"
      />
      <path
        d="M166.625 148.667C177.095 148.667 185.583 140.179 185.583 129.708C185.583 119.238 177.095 110.75 166.625 110.75C156.155 110.75 147.667 119.238 147.667 129.708C147.667 140.179 156.155 148.667 166.625 148.667Z"
        fill="white"
      />
      <path
        d="M183.061 147.955L181.59 148.119L181.218 149.464L192.782 163.245L194.606 161.714L183.061 147.955Z"
        fill="#666B6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.998 150.164L190.547 165.12C191.583 166.354 193.422 166.515 194.657 165.479L196.481 163.949C197.715 162.913 197.876 161.073 196.84 159.84L184.291 144.884L179.305 145.438L177.998 150.164ZM181.59 148.119L183.061 147.955L194.606 161.714L192.782 163.245L181.218 149.464L181.59 148.119Z"
        fill="#666B6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.516 120.984C180.495 125.964 180.495 134.036 175.516 139.016C170.536 143.995 162.464 143.995 157.484 139.016C152.505 134.036 152.505 125.964 157.484 120.984C162.464 116.005 170.536 116.005 175.516 120.984ZM172.439 137.943L158.557 124.061C155.645 127.945 155.955 133.48 159.488 137.012C163.02 140.545 168.555 140.855 172.439 137.943ZM173.512 122.988C177.045 126.52 177.355 132.055 174.443 135.939L160.561 122.057C164.445 119.145 169.98 119.455 173.512 122.988Z"
        fill="#BB3118"
      />
      <circle cx="51.5" cy="70.5" r="2.5" fill="#424242" />
      <circle cx="44.5" cy="70.5" r="2.5" fill="#424242" />
      <circle cx="58.5" cy="70.5" r="2.5" fill="#424242" />
      <path
        d="M106.098 143.384V152H105.282L100.458 145.148V152H99.4017V143.384H100.434L105.042 149.936V143.384H106.098ZM107.244 153.176L110.724 142.868H111.768L108.288 153.176H107.244ZM115.427 144.752L114.023 148.436H116.831L115.427 144.752ZM118.199 152L117.203 149.396H113.651L112.655 152H111.551L114.923 143.384H115.967L119.327 152H118.199Z"
        fill="white"
      />
      <path
        d="M137.105 103.256V109H136.561L133.345 104.432V109H132.641V103.256H133.329L136.401 107.624V103.256H137.105ZM137.829 109.784L140.149 102.912H140.845L138.525 109.784H137.829ZM143.245 104.168L142.309 106.624H144.181L143.245 104.168ZM145.093 109L144.429 107.264H142.061L141.397 109H140.661L142.909 103.256H143.605L145.845 109H145.093Z"
        fill="white"
      />
      <path
        d="M68.5788 89.192V93.5H68.1708L65.7588 90.074V93.5H65.2308V89.192H65.7468L68.0508 92.468V89.192H68.5788ZM69.1219 94.088L70.8619 88.934H71.3839L69.6439 94.088H69.1219ZM73.1837 89.876L72.4817 91.718H73.8857L73.1837 89.876ZM74.5697 93.5L74.0717 92.198H72.2957L71.7977 93.5H71.2457L72.9317 89.192H73.4537L75.1337 93.5H74.5697Z"
        fill="white"
      />
      <path
        d="M70.6051 113.256V119H70.0611L66.8451 114.432V119H66.1411V113.256H66.8291L69.9011 117.624V113.256H70.6051ZM71.3293 119.784L73.6493 112.912H74.3453L72.0253 119.784H71.3293ZM76.7449 114.168L75.8089 116.624H77.6809L76.7449 114.168ZM78.5929 119L77.9289 117.264H75.5609L74.8969 119H74.1609L76.4089 113.256H77.1049L79.3449 119H78.5929Z"
        fill="white"
      />
      <path
        d="M133.821 182.94H131.901C132.181 180.26 133.981 178.42 136.621 178.42C139.341 178.42 141.001 180 141.001 182.44C141.001 184.18 139.701 185.4 138.601 186.58C137.801 187.4 137.621 187.92 137.601 188.48H135.881C135.941 187.3 136.281 186.7 137.221 185.66C138.041 184.74 139.201 183.84 139.201 182.46C139.201 181 138.181 180.06 136.621 180.06C134.901 180.06 133.941 181.26 133.821 182.94ZM137.921 191.84C137.921 192.56 137.361 193.12 136.661 193.12C135.981 193.12 135.421 192.56 135.421 191.84C135.421 191.14 135.981 190.58 136.661 190.58C137.361 190.58 137.921 191.14 137.921 191.84Z"
        fill="#3B2A7B"
      />
      <path
        d="M79.6785 32.892H76.2225C76.7265 28.068 79.9665 24.756 84.7185 24.756C89.6145 24.756 92.6025 27.6 92.6025 31.992C92.6025 35.124 90.2625 37.32 88.2825 39.444C86.8425 40.92 86.5185 41.856 86.4825 42.864H83.3865C83.4945 40.74 84.1065 39.66 85.7985 37.788C87.2745 36.132 89.3625 34.512 89.3625 32.028C89.3625 29.4 87.5265 27.708 84.7185 27.708C81.6225 27.708 79.8945 29.868 79.6785 32.892ZM87.0585 48.912C87.0585 50.208 86.0505 51.216 84.7905 51.216C83.5665 51.216 82.5585 50.208 82.5585 48.912C82.5585 47.652 83.5665 46.644 84.7905 46.644C86.0505 46.644 87.0585 47.652 87.0585 48.912Z"
        fill="#3B2A7B"
      />
    </SvgIcon>
  );
}
